import React, { useEffect, useRef } from 'react';
import Link from '../../../Link';
import { Badge } from '../../../Badge';
import { MyCadastre } from '../MyCadastre';
import * as Styles from './styles';
import getLinks from '../../utils/links';
import { ChevronRight } from '../Icons';
import { sendClickEvent } from '../../utils';
import { useScrollLock, useOverflowNavigation, useClickOutsideOverflow } from '../../services';
import { Banner } from '../Banner';
import { Overlay } from '../Overlay';
export const OldOverflowMenu = ({ headerWrapperRef, openSubMenu, setOpenSubMenu, accountInfo, activeTestABFeaturedMenu, fixed, hasActiveTestAB, }) => {
    var _a, _b;
    const firstMenuItem = useRef(null);
    const wrapperRef = useRef(null);
    const { profilePicture, userName, publicAccountId } = accountInfo;
    const links = getLinks(publicAccountId, hasActiveTestAB);
    const { lockScroll, unlockScroll } = useScrollLock();
    const menuButton = (_a = headerWrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.burger-menu');
    const profileButton = (_b = headerWrapperRef.current) === null || _b === void 0 ? void 0 : _b.querySelector('[data-ds-component="DS-Profile-Button"]');
    useOverflowNavigation({
        openSubMenu,
        setOpenSubMenu,
        menuButton,
        profileButton,
        wrapperRef,
    });
    useClickOutsideOverflow({
        openSubMenu,
        setOpenSubMenu,
        menuButton,
        profileButton,
        wrapperRef,
    });
    useEffect(() => {
        const isMobile = window.document.body.clientWidth < 840;
        if (openSubMenu && isMobile) {
            lockScroll();
        }
        else {
            unlockScroll();
        }
    }, [lockScroll, openSubMenu, unlockScroll]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Overlay, { open: openSubMenu, onClick: () => setOpenSubMenu(false) }),
        React.createElement(Styles.OverflowWrapper, { id: "ds-overflow-menu", "aria-hidden": !openSubMenu, "aria-expanded": openSubMenu, "data-fixed": fixed, "data-islogged": userName, "data-testab": hasActiveTestAB, ref: wrapperRef, "data-testid": "overflow-menu" }, links.map((link, index) => {
            if (!activeTestABFeaturedMenu && link.title === 'Banner') {
                return null;
            }
            return (React.createElement(Styles.FlyOutItem, { key: `fly-out-item-${index}`, "data-open": openSubMenu, "data-divider": link.divider, "data-haspos": activeTestABFeaturedMenu },
                React.createElement(Link, { href: link.href, tabIndex: openSubMenu ? 0 : -1, className: "olx-header__menu-link", ref: index === 0 ? firstMenuItem : null, onClick: () => sendClickEvent(link.objectDetail, 'sub_menu', { login: accountInfo.isLogged }) },
                    link.title === 'Meu cadastro' && (React.createElement(MyCadastre, { link: link, profilePicture: profilePicture, userName: userName })),
                    activeTestABFeaturedMenu && link.title === 'Banner' && React.createElement(Banner, null),
                    link.title !== 'Meu cadastro' && link.title !== 'Banner' && (React.createElement(React.Fragment, null,
                        React.createElement(link.Icon, { size: "16" }),
                        link.title,
                        hasActiveTestAB && React.createElement(ChevronRight, { className: "olx-header__menu-arrow" }),
                        link.badge && !activeTestABFeaturedMenu && (React.createElement(Styles.FlyOutLinkBadge, null,
                            React.createElement(Badge, { "aria-label": "Novo" }, "Novo"))))))));
        }))));
};
OldOverflowMenu.displayName = 'OldOverflowMenu';
